// extracted by mini-css-extract-plugin
module.exports = {"container":"Quote_container__3Fb8T","textContainer":"Quote_textContainer__3FCuq","authorName":"Quote_authorName__2KTBR"};